module.exports = __webpack_public_path__ + "static/uberEatsLogo-7925a6675ee01af477aea186c83dcd92.svg";